var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-record-block d-flex justify-center align-center white--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('noRecord'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }